import { render, staticRenderFns } from "./ChartJS.vue?vue&type=template&id=4b8aa764"
import script from "./ChartJS.vue?vue&type=script&lang=js"
export * from "./ChartJS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports